import React, { useEffect, useState } from 'react'
import {
    Button,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from '@material-ui/core'
import { REQUIRED_MESSAGE } from '../../../constants';
import * as yup from "yup";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { styleExam } from '../styleExam';

const initialStateForm = {
    documentType: "",
    document: "",
    examType: "",
}

const FormCreateOrderExam = ({dataMaestras, onSubmit}) => {
    const classes = styleExam();
    const [validateNumber, setValidateNumber] = useState(false);

    const schema = yup.object().shape({
        documentType: yup.string()
            .required(REQUIRED_MESSAGE),
        document: validateNumber
            ? yup
            .string()
            .required(REQUIRED_MESSAGE)
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(16, "Ingrese máximo 16 caracteres")
            .matches(
            /^([0-9A-Za-zÑñ]{0,16})$/,
            "Ingrese un número de identificación válido"
            )
        : yup
            .string()
            .required(REQUIRED_MESSAGE)
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(16, "Ingrese máximo 16 caracteres")
            .matches(
            /^([0-9]{0,16})$/,
            "Ingrese un número de identificación válido"
            ),
        examType: yup.string()
            .nullable()
            .required(REQUIRED_MESSAGE),
    });

    const {register, handleSubmit, control, formState: {errors}, watch, getValues } = useForm({
        resolver: yupResolver(schema),
        initialStateForm,
        mode: "all", 
        reValidateMode: "onChange"
    });

    const handleUserKeyPressDocumento = (e) => {
        var form = getValues();
        if (form.documentType !== "PP" ) {
          let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
          if (!validChars.includes(e.key)) {
            e.preventDefault();
          }
        }
    };

    const validateTypeDocumentPastport = (watch("documentType") === "PP");

    useEffect(() => {
        if (validateTypeDocumentPastport ) {
            setValidateNumber(true);
        }else{
            setValidateNumber(false);
        }
    }, [validateTypeDocumentPastport ]);
    
  return (
    <div className={classes.divFormCreate}>
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} > 
                <Grid item xs={12} md={3} lg={3}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        className={classes.formControlGen}
                        size="small"
                        error={
                        !!errors.hasOwnProperty("documentType") &&
                        errors["documentType"].message
                        }
                    >
                        <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                            Tipo de documento *
                        </InputLabel>
                        <Controller
                            fullWidth
                            control={control}
                            name="documentType"
                            size="small"
                            defaultValue=''
                            render={(props) => (
                                <Select
                                    inputRef={register}
                                    className={classes.inputForm }
                                    label="Cargo a desempeñar *"
                                    notched={true}
                                    size="small"
                                    onChange={(e) => {
                                        props.onChange(e);
                                    }}
                                    inputProps={{
                                        name: "documentType",
                                        id: "outlined-select-documentType",
                                    }}
                                    value={props.value}
                                >
                                    {dataMaestras?.maestras?.tipoDocumnetoIdentificacion.map((res) => (
                                            <MenuItem
                                                className={classes.menuItem}
                                                key={res?.key}
                                                value={res?.key}
                                            >
                                                {res?.value}
                                            </MenuItem>
                                        ))}
                                </Select>
                            )}
                        />
                        <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                            {errors.hasOwnProperty("documentType") && errors["documentType"].message}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3} lg={3} >
                    <FormControl
                        fullWidth
                    > 
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            inputRef={register}
                            id="numDocumentExam"
                            type="text"
                            name="document"
                            defaultValue=""
                            className={classes.inputForm }
                            label="Número Documento *"
                            variant="outlined"
                            fullWidth
                            size="small"
                            margin="dense"
                            error={errors.hasOwnProperty('document') && errors['document'].message}
                            onKeyPress={handleUserKeyPressDocumento }
                        />
                        <FormHelperText style={{color: "#f44336", paddingLeft: 14}} >
                            {errors.hasOwnProperty('document') && errors['document'].message}                          
                        </FormHelperText> 
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        className={classes.formControlGen}
                        size="small"
                        error={
                            !!errors.hasOwnProperty("examType") &&
                            errors["examType"].message
                        }
                    >
                        <InputLabel htmlFor="outlined-select-examType" shrink={true}>
                            Tipo de examen *
                        </InputLabel>
                        <Controller
                            fullWidth
                            name="examType"
                            control={control}
                            size="small"
                            defaultValue=""
                            render={(props) => (
                                <Select
                                    inputRef={register}
                                    label="Tipo de examen *"
                                    notched={true}
                                    className={classes.inputForm }
                                    inputProps={{
                                        name: "examType",
                                        id: "outlined-select-examType",
                                    }}
                                    value={props.value}
                                    onChange={(e) => {
                                        props.onChange(e);
                                    }}
                                >
                                    {dataMaestras?.maestras?.tipoOrdenExamenMedico?.map(res => (
                                        <MenuItem
                                            className={classes.menuItem}
                                            key={res?.clave}
                                            value={res?.clave}
                                        >
                                            {res?.valor}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />    
                        <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                        {errors.hasOwnProperty("examType") && errors["examType"].message}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                    <Button 
                        type="submit" 
                        variant="contained" 
                        className={classes.buttonContinue}
                    >
                        Continuar
                    </Button>
                </Grid>
            </Grid>
        </form>
    </div>
  )
}

export default FormCreateOrderExam